export const LINKEDIN = 'https://www.linkedin.com/in/valentyn-grekulov-04733462/';
export const PATREON = 'https://www.patreon.com/join/Memo766';
